import { render, staticRenderFns } from "./ClaimType.vue?vue&type=template&id=24186448&"
import script from "./ClaimType.vue?vue&type=script&lang=js&"
export * from "./ClaimType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24186448')) {
      api.createRecord('24186448', component.options)
    } else {
      api.reload('24186448', component.options)
    }
    module.hot.accept("./ClaimType.vue?vue&type=template&id=24186448&", function () {
      api.rerender('24186448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimType/ClaimType.vue"
export default component.exports